(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-product-form')) {
    customElements.define('campaign-product-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.qtyInput = this.form.querySelector('input[name="quantity"]');
        this.planSelect = this.querySelector('[data-plan-select]');
        this.button = this.querySelector('[data-add-button]');
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.strings = JSON.parse(this.dataset.strings);
        this.preorder = this.dataset.preorder === 'true';

        this.querySelectorAll('[data-variant-button]').forEach((btn) => {
          btn.addEventListener('click', () => this.selectVariant(btn.dataset.variantButton));
        });

        this.querySelectorAll('[data-purchase-type]').forEach((radio) => {
          radio.addEventListener('change', () => this.render());
        });

        if (this.planSelect) {
          this.planSelect.addEventListener('change', () => this.render());
        }

        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        this.render();
      }

      get root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      get currentVariant() {
        return this.variants.find((v) => String(v.id) === this.idInput.value);
      }

      get isSubscription() {
        const checked = this.querySelector('[data-purchase-type]:checked');
        return !!checked && checked.value === 'subscription';
      }

      setText(selector, text) {
        const el = this.querySelector(selector);
        if (el) el.textContent = text || '';
      }

      selectVariant(id) {
        this.idInput.value = id;
        this.querySelectorAll('[data-variant-button]').forEach((btn) => {
          const selected = btn.dataset.variantButton === String(id);
          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-pressed', selected);
        });
        this.render();
      }

      render() {
        const variant = this.currentVariant;
        if (!variant) return;

        const planId = this.planSelect ? this.planSelect.value : null;
        const subPrice = planId ? variant.plans[planId] : null;

        // If this variant has no subscription price, fall back to one-time
        const subRadio = this.querySelector('[data-purchase-type][value="subscription"]');
        if (subRadio) {
          subRadio.disabled = !subPrice;
          if (!subPrice && subRadio.checked) {
            const oneTime = this.querySelector('[data-purchase-type][value="onetime"]');
            if (oneTime) oneTime.checked = true;
          }
        }

        const subscribing = this.isSubscription && !!subPrice;
        if (this.planSelect) this.planSelect.disabled = !subscribing;
        this.classList.toggle('is-subscription', subscribing);

        this.setText('[data-onetime-price]', variant.price);
        this.setText('[data-subscription-price]', subPrice);
        this.setText('[data-price]', subscribing ? subPrice : variant.price);

        const compare = this.querySelector('[data-compare-price]');
        if (compare) {
          compare.textContent = !subscribing && variant.compareAtPrice ? variant.compareAtPrice : '';
          compare.hidden = !compare.textContent;
        }

        this.button.disabled = !variant.available;
        if (!variant.available) {
          this.button.textContent = this.strings.soldOut;
        } else {
          this.button.textContent = this.preorder ? this.strings.preorder : this.strings.addToCart;
        }
      }

      async handleSubmit(event) {
        event.preventDefault();

        const variant = this.currentVariant;
        if (!variant || !variant.available) return;

        const item = {
          id: Number(variant.id),
          quantity: Math.max(1, parseInt(this.qtyInput.value, 10) || 1),
        };

        if (this.isSubscription && this.planSelect && !this.planSelect.disabled) {
          item.selling_plan = Number(this.planSelect.value);
        }

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.setText('[data-error]', '');

        try {
          const response = await fetch(`${this.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          });
          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || this.strings.error);
          }

          // Hook your cart drawer / cart count into this event
          document.dispatchEvent(new CustomEvent('campaign-products:added', {
            detail: { item, response: data },
          }));

          if (this.dataset.afterAdd === 'cart') {
            window.location.href = `${this.root}cart`;
            return;
          }

          this.button.textContent = this.strings.added;
          setTimeout(() => this.render(), 2000);
        } catch (error) {
          this.setText('[data-error]', error.message || this.strings.error);
          this.render();
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
